const ADD_ASSIGNMENT = `
  mutation addAssignment($input: AddAssignmentInput!) {
    addAssignment(input: $input) {
      assignmentId
      assignmentType
      createdAt
      dateFrom
      dateTo
      entityId
      entityType
      parentId
      status
      manifest {
        activityType
        locale
        sequence
        status
        storyId
        activity {
          activityId
          assignmentId
          displayStatus
          status
          storyId
          tags
          type
        }
      }
    }
  }`;

export default ADD_ASSIGNMENT;